module.exports = __webpack_public_path__ + "media/images/icon-focus-cda889e2420fe4a84fe5b09dc512dfa1.svg";